import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

/**
 * Created by wupeng on 2019/8/10.
 */
//验证用户名规则
export function userNameVerify(val) {
  var patrn = /^(\w){6,30}$/;

  if (patrn.exec(val)) {
    return true;
  }

  return false;
} //验证密码规则

export function passwordVerify(val) {
  // let patrn = /^[~!@#￥$%&*0-9A-z]{6,30}$/;
  var patrn = /^(?=.*[0-9])((?=.*[A-Z])|(?=.*[a-z]))(?=.*[!@#¥$%^&*~\\.])[0-9a-zA-Z!@#¥$%^&*~\\.]{8,30}/;

  if (patrn.exec(val)) {
    return true;
  }

  return false;
} //验证短信验证码规则

export function msgNumVerify(val) {
  var patrn = /^[0-9]{6}$/;

  if (patrn.exec(val)) {
    return true;
  }

  return false;
} //验证手机号

export function phoneVerify(val) {
  var patrn = /^1\d{10}$/;

  if (patrn.exec(val)) {
    return true;
  }

  return false;
}
/**
 * 0-99 正则校验
 *
 * @param {Number} val 输入的数字
 */

export function checkOneNum(val) {
  var patrn = /^(?:[0-9]|[1-9][0-9])$/;

  if (patrn.exec(val)) {
    return true;
  }

  return false;
}
/**
 * 存储localStorage
 */

export function setLocalStorage(name, content) {
  if (!name) return;

  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }

  window.localStorage.setItem(name, content);
}
/**
 * 获取localStorage
 */

export function getLocalStorage(name) {
  if (!name) return;
  return JSON.parse(window.localStorage.getItem(name));
}
/**
 * 删除localStorage
 */

export function removeLocalStorage(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
}
/**
 * 存储SessionStorage
 */

export function setSessionStorage(name, content) {
  if (!name) return;

  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }

  window.sessionStorage.setItem(name, content);
}
/**
 * 获取SessionStorage
 */

export function getSessionStorage(name) {
  if (!name) return;
  return window.sessionStorage.getItem(name);
}
/**
 * 删除SessionStorage
 */

export function removeSessionStorage(name) {
  if (!name) return;
  window.sessionStorage.removeItem(name);
}
/**
 * 获取年月日
 *
 * @param {String} dateStr 时间毫秒数
 * @returns 格式化后的时间
 */

export function getYearMonthDay(dateStr) {
  if (!dateStr) return '';
  return formatDate(dateStr, 'yyyy-MM-dd');
}
/**
 * 获取年月日 时分秒
 *
 * @param {String} dateStr 时间毫秒数
 * @returns 格式化后的时间
 */

export function getDate(dateStr) {
  if (!dateStr) return '';
  return formatDate(dateStr, 'yyyy-MM-dd HH:mm:ss');
}
/**
 * 格式化时间
 *
 * @param {String} dateStr 时间毫秒数
 * @returns 格式化后的时间
 */

export function formatDate(dateStr, format) {
  if (!dateStr) return '';
  var date = new Date(parseInt(dateStr));
  return date.pattern(format);
}
/** * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
 可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
 Date()).pattern('yyyy-MM-dd hh:mm:ss.S')==> 2006-07-02 08:09:04.423
 * (new Date()).pattern('yyyy-MM-dd E HH:mm:ss') ==> 2009-03-10 二 20:09:04
 * (new Date()).pattern('yyyy-MM-dd EE hh:mm:ss') ==> 2009-03-10 周二 08:09:04
 * (new Date()).pattern('yyyy-MM-dd EEE hh:mm:ss') ==> 2009-03-10 星期二 08:09:04
 * (new Date()).pattern('yyyy-M-d h:m:s.S') ==> 2006-7-2 8:9:4.18
 */

Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    // 月份
    'd+': this.getDate(),
    // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12,
    // 小时
    'H+': this.getHours(),
    // 小时
    'm+': this.getMinutes(),
    // 分
    's+': this.getSeconds(),
    // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3),
    // 季度
    S: this.getMilliseconds() // 毫秒

  };
  var week = {
    '0': "\u65E5",
    '1': "\u4E00",
    '2': "\u4E8C",
    '3': "\u4E09",
    '4': "\u56DB",
    '5': "\u4E94",
    '6': "\u516D"
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "\u661F\u671F" : "\u5468" : '') + week[this.getDay() + '']);
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }

  return fmt;
}; // 日期转换


export function covertTime(str) {
  if (str === null || str === undefined || str === '') {
    return '';
  } else {
    return str.substring(0, 10);
  }
} // 年月之间插入 '/' 日期添加

export function joinDivision(str) {
  if (str === '' || str === undefined || str === '') {
    return '';
  }

  if (typeof str === 'number') {
    str = '' + str;
  }

  var len = str.length;
  var newStr = '';

  if (len == 8) {
    newStr = str.substring(0, 4) + '/' + str.substring(4, 6) + '/' + str.substring(6, len);
  } else if (len == 6) {
    newStr = str.substring(0, 4) + '/' + str.substring(4, 6);
  } else if (len == 4) {
    newStr = str.substring(0, 4);
  }

  return newStr;
}